import Vue from 'vue'
import Vuex from 'vuex'
import Utils from '@/core/utils'
import api from '@/api/index'
import user from './modules/user'
import common from './modules/common'
import breadCrumbInfo from './modules/breadCrumbInfo'
import classifySpace from './modules/classify/space'
import resourceDetail from './modules/resource/detail'
import feedback from './modules/feedback'
import fileModel from './modules/fileModel'
import staticConfig from './modules/staticConfig'
import adPoster from './modules/adPoster'

Vue.use(Vuex)
api.inject(Vuex.Store)

const state = {
  // 平台信息，默认web
  platform: 'web',
  softwareCode: null,
  softwareVersion: null,
  spacesDetail: {},
  localAppData: null,
  loginAppDataPath: null,
  desktopInfo: null,
  // 是否显示反馈红包活动
  showBonus: false,
  // 插件的缓存地址
  pluginCachePath: null,
}
const getters = {
  platform: (state) => { return state.platform },
  softwareCode: (state) => { return state.softwareCode },
  softwareVersion: (state) => { return state.softwareVersion },
  // 是否是基建软件（道路、桥梁）
  isCapitalSoftware: (state) => { return ['AppGbr', 'AppGroad'].includes(state.softwareCode) },
  spacesDetail: (state) => { return state.spacesDetail },
  localAppData: (state) => { return state.localAppData },
  loginAppDataPath: (state) => { return state.loginAppDataPath },
  desktopInfo: (state) => { return state.desktopInfo },
  showBonus: (state) => { return state.showBonus },
  pluginCachePath: (state) => { return state.pluginCachePath },
  canUpdateCachePath: (state) => {
    const platform = state.platform
    const softwareCode = state.softwareCode
    const desktopInfo = state.desktopInfo || {}
    if (platform === 'r') {
      return Utils.isHigherVersion(desktopInfo.pluginVersion, '3.6.42.1')
    } else if (platform === 'g') {
      const softwareCodeSpecial = ['AppGbr', 'AppGroad']
      return softwareCodeSpecial.includes(softwareCode) || Utils.isHigherVersion(state.softwareVersion, '0.45')
    }
  },
  canEmitWebEventToDesktop: (state) => {
    const desktopInfo = state.desktopInfo || {}
    return Utils.compareVersion(desktopInfo.desktopVersion, '1.3.0.0') >= 0
  }
}
const mutations = {
  setPlatform(state, data) {
    state.platform = data
  },
  setSoftwareCode(state, data) {
    state.softwareCode = data
  },
  setSoftwareVersion(state, data) {
    state.softwareVersion = data
  },
  setLocalAppData(state, data) {
    state.localAppData = data
  },
  setLoginAppDataPath(state, data) {
    state.loginAppDataPath = data
  },
  setDesktopInfo(state, data) {
    state.desktopInfo = data
  },
  setPluginCachePath(state, data) {
    state.pluginCachePath = data
  },
  setShowBonus(state, data) {
    state.showBonus = data
  },
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    user,
    classifySpace,
    resourceDetail,
    common,
    breadCrumbInfo,
    feedback,
    fileModel,
    staticConfig,
    adPoster
  },
  // strict: debug
})
